import {all} from "redux-saga/effects";

/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([

    ]);
}